// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"6bee9a19","308":"8a213024","361":"0b6e2c2a","471":"4851818d","547":"9f1f6a2f","565":"bb0478e1","576":"d314e48b","684":"b5b62dd7","837":"38edaf9e","839":"a184d551","982":"2be4a4ad","990":"590b5f31"}[chunkId] + ".chunk.js";
};